"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBSignaturePaperPositive = function SvgBSignaturePaperPositive(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "none",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M81.413 98.341a2.107 2.107 0 01-1.49-3.596l35.825-35.824a2.107 2.107 0 012.964 2.97L82.888 97.717c-.39.395-.92.62-1.475.625zM109.876 79.137a2.107 2.107 0 01-1.49-3.597l6.709-6.701a2.107 2.107 0 012.978 2.978l-6.708 6.709a2.107 2.107 0 01-1.49.61z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M78.498 110.452H25.372a2.107 2.107 0 110-4.215h53.126a2.107 2.107 0 110 4.215zM81.813 44.05H22.057a2.107 2.107 0 110-4.215h59.756a2.107 2.107 0 110 4.215zM81.813 70.61H22.057a2.107 2.107 0 110-4.215h59.756a2.107 2.107 0 010 4.214zM81.813 57.326H22.057a2.107 2.107 0 110-4.215h59.756a2.107 2.107 0 010 4.215z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M41.943 103.448c-1.398.02-2.79-.16-4.138-.534-3.112-.913-5.113-3.126-5.5-6.076a8.682 8.682 0 01.323-3.624c-3.378-2.95-4.53-7.516-2.992-12.476a2.108 2.108 0 014.032 1.23c-.885 2.88-.52 5.458.983 7.298a22.583 22.583 0 016.547-5.781c5.62-3.414 10.03-2.15 11.724.478 1.524 2.367 1.046 6.132-3.45 9.216-4.214 2.865-8.976 3.631-13.001 2.247a3.913 3.913 0 000 .864 3.168 3.168 0 002.5 2.578c5.423 1.58 14.534-2.05 16.55-4.98a2.107 2.107 0 013.695 1.967 10.74 10.74 0 00-.703 2.922c3.555-.225 5.353-3.632 5.62-4.173l.056-.119a2.107 2.107 0 013.828 1.75l-.049.119c-.436.94-.64 2.198-.421 2.556 0 .057.28.218.969.24.344 0 1.405.055 2.585-1.504a2.108 2.108 0 013.358 2.55c-1.637 2.156-3.744 3.252-6.098 3.168-2.55-.091-3.8-1.264-4.404-2.24a9.834 9.834 0 01-6.181 1.847 3.4 3.4 0 01-2.81-1.532 3.884 3.884 0 01-.548-1.405 27.079 27.079 0 01-12.475 3.414zm-3.744-11.892c2.711.787 5.97.147 8.893-1.855 2.156-1.482 2.634-2.908 2.29-3.456-.457-.702-2.677-1.173-6 .843a18.558 18.558 0 00-5.183 4.468z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M101.643 63.873a2.107 2.107 0 01-2.107-2.108V4.215H22.97L10.228 16.957a2.107 2.107 0 01-2.979-2.978L20.596.632A2.105 2.105 0 0122.099 0h79.544c1.164 0 2.107.943 2.107 2.107v59.658a2.107 2.107 0 01-2.107 2.108z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M101.643 143.656H2.107A2.107 2.107 0 010 141.548V25.288c0-1.164.943-2.108 2.107-2.108H23.23V12.068a2.107 2.107 0 014.214 0v13.22a2.107 2.107 0 01-2.107 2.107H4.215v112.046h97.428a2.107 2.107 0 010 4.215z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M101.643 133.758a2.107 2.107 0 01-2.107-2.107V91.76a2.107 2.107 0 014.214 0v39.891a2.107 2.107 0 01-2.107 2.107z",
    fill: "#1B7"
  })));
};

var _default = SvgBSignaturePaperPositive;
exports["default"] = _default;